module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAMAAADzapwJAAAAbFBMVEUAAACAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIBW6cXKAAAAI3RSTlMA53W/hibYmRn139K6oY6AfFlUNB4QCPLNx7Crpm1lXEo9Lhpb9kUAAACJSURBVBjTddHZEoIwDIXh0xZLZRcQ9zXv/46OtINtDP/lN5lcJABu9rQBb7oSUfHnGX07cybfTubSiUyPlI+B+5Q7r2af8qhm1mC14jQmM3sG1rCy5k7yfOM9HzFoHZ0n924vB6Ki5R4yb3bIkPodTm8pCktPKzJcvWiFuL72m0r+w1dXKdU4fADPhxc37giD9gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-phone.png
// module id = enwd
// module chunks = 21